
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import { CaseField } from "@/types/caseField"
import { caseColumns } from "@/types/caseColumns"

import CaseFieldDisplay from "@/components/Search/CaseFieldDisplay.vue"
import UserImage from "@/components/UserImage.vue"

import { get } from "lodash"

@Component({
	components: {
		"user-image": UserImage,
		"case-field-display": CaseFieldDisplay,
		"scrollbar": VuePerfectScrollbar
	}
})
export default class CasePreview extends Vue {
	@Prop()
	caseDetails: any;

	private get globalColumns (): any[] {
		if (!this.caseDetails) {
			return []
		}

		const hideUsers = Object.keys(this.caseDetails.fields)
			.some(fieldId => this.caseDetails.fields[fieldId].dataType === "user-role")

		const globalColumns = caseColumns.filter(c => c.key !== "caseNumber" && c.key !== "title" &&
			(!hideUsers || (c.key !== "users" && c.key !== "assigneeId")))
		globalColumns.forEach(c => {
			c.value = get(this.caseDetails, c.key)
			if (c.displayKey) {
				c.valueLabel = get(this.caseDetails, c.displayKey)
			}
		})

		const assignee = globalColumns.find(g => g.key === "assigneeId")
		const users = globalColumns.find(g => g.key === "users")
		if (assignee && users) {
			assignee.valueObject = users.value!.find((u: any) => u.id === this.caseDetails.assigneeId)
			users.valueObject = users.value!.filter((u: any) => u.id !== this.caseDetails.assigneeId)
		}

		return globalColumns
	}

	private get sections (): any[] {
		if (!this.caseDetails) {
			return []
		}

		const allFields: CaseField[] = []

		if (this.caseDetails.fields) {
			Object.keys(this.caseDetails.fields).forEach(fieldId => {
				const field = this.caseDetails.fields[fieldId]
				if (field) {
					allFields.push(field)
				}
			})
		}

		allFields.forEach((field: CaseField) => {
			if (this.caseDetails!.sections) {
				const sectionOrder = this.caseDetails!.sections.indexOf(field.section)
				field.sectionOrder = sectionOrder === -1 ? 99999 : sectionOrder
			}

			if (field.field.dataType) {
				field.dataType = field.field.dataType
			}
			if (field.label) {
				field.valueLabel = field.label
			}
		})

		const caseFields = allFields.sortByThen({ key: "sectionOrder" }, { thenKey: "order" })

		return caseFields.reduce((group: any, field: CaseField) => {
			var section = field.section ? field.section : "General";
			(group[section] = group[section] || []).push(field)
			return group
		}, {})
	}

	getValue (key: string) {
		return get(this.caseDetails, key)
	}
}

